import React from 'react';
import { Document } from '../Data/ApplicationDocumentData';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export interface ApplicationWorkflowDocumentProps {
  document: Document;
  onDelete: (document: Document) => void;
}

export const ApplicationWorkflowDocument: React.FC<ApplicationWorkflowDocumentProps> = (props) => {
  return (
    <React.Fragment>
      <ListItem>
        <ListItemIcon>
          <DescriptionIcon />
        </ListItemIcon>
        <ListItemText
          primary={props.document.file ? props.document.file.name : props.document.name}
          secondary={props.document.file ? props.document.file.type.toString() : null}
        />
        <ListItemSecondaryAction>
          <IconButton aria-label='delete document' onClick={() => props.onDelete(props.document)} style={{ color: '#8b0000' }}>
            <Tooltip title='Delete document' aria-label='Delete document'>
              <DeleteIcon />
            </Tooltip>
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </React.Fragment>
  );
};
